import Glide from '@glidejs/glide';

export default {
  init() {
    // JavaScript to be fired on all pages


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $('.thumbnail-popover').popover({
      trigger: 'hover',
      placement: 'bottom',
    });

    function generateBulletsAndMountGlide() {
      var bulletCount = document.querySelectorAll('.glide__slide').length;
      var bulletWrapper = document.getElementsByClassName('glide__bullets');

      for (let index = 0; index < bulletCount; index++) {
        const button = document.createElement('button');
        button.className = 'glide__bullet';
        button.setAttribute('data-glide-dir', '=' + index);

        bulletWrapper[0].appendChild(button);
      }
    }
    // Slider
    if ($('.glide').length > 0) {

      generateBulletsAndMountGlide();

      const sliderInstance = document.getElementsByClassName('slider');
      Object.keys(sliderInstance).forEach(key => {
        new Glide(
          sliderInstance[key],
          {
            type: 'carousel',
            perView: 1,
            focusAt: 'center',
            autoplay: 3500,
          }
        ).mount();
      });
    }


    $('#requestModal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget);
      var recipient = button.data('type');
      var buttonTxt = button.text().trim();
      console.log(button, buttonTxt);
      var modal = $(this);
      modal.find('.modal-title').text(buttonTxt);
      modal.find('#requestType input').val(buttonTxt);
      console.log(recipient);
      // modal.find('.modal-body input').val(recipient);
    })

    $('.product-block').each(function () {
      const blockID = $(this).data('block');
      const secondarySliderRef = '#secondary-slider-' + blockID;
      const primarySliderRef = '#primary-slider-' + blockID;


      if ($(primarySliderRef).length) {
        $(primarySliderRef).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: secondarySliderRef,
        });
      }

      if ($(secondarySliderRef).length) {
        $(secondarySliderRef).slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: primarySliderRef,
          dots: false,
          centerMode: true,
          focusOnSelect: true,
        });
      }
     
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js